/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */


function handleInitialAdjustments({ questionnaire, insurers }) {
  let mrc2AttachmentQuestions = questionnaire.filter((qs) => qs.idQuestion === 1962);
  const cloneMrc2AttachmentQuestion = JSON.parse(JSON.stringify(mrc2AttachmentQuestions[0]));

  const questionsByInsurers = [];

  insurers.map((insurer) => {
    const insurerQuestion = mrc2AttachmentQuestions.find((question) => question.answer
      && JSON.parse(question.answer).length
      && JSON.parse(question.answer)[0].idPersonDocument == insurer.idPersonInsurer
    );

    if (insurerQuestion) {
      mrc2AttachmentQuestions = mrc2AttachmentQuestions.filter((question) =>
        (question.answer && JSON.parse(question.answer).length && JSON.parse(question.answer)[0].idPersonDocument != insurer.idPersonInsurer)
        || !question.answer
        || !JSON.parse(question.answer).length
      );

      questionsByInsurers.push({
        ...insurerQuestion,
        idPersonInsurer: insurer.idPersonInsurer,
        behaviorObject: {
          ...insurerQuestion.behaviorObject,
          labelDescription: insurer.nmInsurer
        }
      });
    }
  })

  const insurersWithoutAnswer = insurers.filter((insurer) => !questionsByInsurers.find((question) => question.idPersonInsurer == insurer.idPersonInsurer));

  insurersWithoutAnswer.forEach((insurer) => {
    if (mrc2AttachmentQuestions.length) {
      const unusedQuestion = mrc2AttachmentQuestions.shift();

      questionsByInsurers.push({
        ...unusedQuestion,
        idPersonInsurer: insurer.idPersonInsurer,
        behaviorObject: {
          ...unusedQuestion.behaviorObject,
          labelDescription: insurer.nmInsurer
        },
        answer: "",
        answerJson: "",
      });
    } else {
      questionsByInsurers.push({
        ...cloneMrc2AttachmentQuestion,
        idPersonInsurer: insurer.idPersonInsurer,
        behaviorObject: {
          ...cloneMrc2AttachmentQuestion.behaviorObject,
          labelDescription: insurer.nmInsurer
        },
        idQuestionnaireAnswers: null,
        answer: "",
        answerJson: "",
      });
    }
  });

  questionnaire = questionnaire.filter((qs) => qs.idQuestion !== 1962);

  questionsByInsurers.sort((a, b) => insurers.findIndex((insurer) => insurer.idPersonInsurer === a.idPersonInsurer) - insurers.findIndex((insurer) => insurer.idPersonInsurer === b.idPersonInsurer));

  questionnaire.push(...questionsByInsurers);

  questionnaire = questionnaire.map((question) => {
    if (question.idQuestion === 1945 && (question.idAnswerOption === 7598 || question.visibleQuestion === 0)) {
      questionnaire = questionnaire.map((qst) => {
        if (qst.idQuestion === 1962) {
          qst.visibleQuestion = 0;
        }
        return qst;
      })
    }

    if (question.idQuestion === 1962) {
      if (question.answer !== '' && JSON.parse(question.answer).length > 0) {
        question.hiddenInput = true;
      }
    }
    return question
  })

  return questionnaire;
}

function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  documentsToDelete,
  setDocumentsToDelete
}) {
  try {
    let saveQuestionnaire = false;

    const newQuestionnaireAnswersToDelete = []
    const newDocumentsToDelete = []

    if (question.idQuestion === 1962) {
      saveQuestionnaire = true;

      if (!Array.isArray(value)) {
        const attachment = question?.answer?.length ? question?.answer[0] : null;
        if (attachment) {
          newDocumentsToDelete.push(attachment.documentId)
        }
      } else {
        if (question.idQuestionnaireAnswers) {
          setQuestionnaireAnswersToDelete([
            ...questionnaireAnswersToDelete
              .filter((idQuestionnaireAnswers) => idQuestionnaireAnswers !== question.idQuestionnaireAnswers),
          ])
        }
      }

      questionnaireUpdated = questionnaireUpdated.map((qst) => {
        if (qst.key === question.key) {
          qst.hiddenInput = value.length;
          qst.answer = qst.answerJson = value?.length ? value : []
          setFieldValue(qst.key, value?.length ? value : [])
        }
        return qst;
      })
    }

    if (newQuestionnaireAnswersToDelete.length) {
      setQuestionnaireAnswersToDelete([
        ...questionnaireAnswersToDelete,
        ...newQuestionnaireAnswersToDelete
          .filter((idQuestionnaireAnswers) => idQuestionnaireAnswers)
          .filter((idQuestionnaireAnswers) => !questionnaireAnswersToDelete.includes(idQuestionnaireAnswers))
      ]);
    }

    if (newDocumentsToDelete.length) {
      setDocumentsToDelete([
        ...documentsToDelete,
        ...newDocumentsToDelete
          .filter((documentId) => !documentsToDelete.includes(documentId))
      ]);
    }

    if (saveQuestionnaire) setQuestionnaire(questionnaireUpdated)
  } catch (e) {
    console.log('MRC2_ATTACHMENTS - handleQuestionChange - error', e);
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange
};

export { events };